import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import React from 'react';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Filler, Tooltip, Legend);

interface AreaLineChartProps {
  labels: string[];
  dataPoints: number[];
  showXScale?: boolean;
  showYScale?: boolean;
  currentTimeIndex?: number;
}

const AreaLineChart: React.FC<AreaLineChartProps> = ({ labels, dataPoints, showXScale = true, showYScale = true }) => {
  const data: ChartData<'line'> = {
    labels,
    datasets: [
      {
        label: 'My Dataset',
        data: dataPoints,
        fill: true,
        backgroundColor: 'rgba(75,192,192,0.2)',
        borderColor: 'rgba(75,192,192,1)',
        tension: 0.4, // curved line
        pointRadius: 0,
      },
    ],
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: showXScale,
        min: labels[0],
        max: labels[labels.length - 1],
        ticks: {
          font: {
            size: 11,
          },
        },
      },
      y: {
        display: showYScale,
        beginAtZero: true,
        max: 100,
        ticks: {
          font: {
            size: 11,
          },
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default AreaLineChart;
